import React from "react";
import { useTranslation } from "react-i18next";

import { InfoPlate } from "fe-shared/src/components";

import { getPickupRequestStatusVariant } from "../../helpers/pickupRequestStatus";
import { PickupRequestStatus } from "../../types";

interface Props {
  status: PickupRequestStatus;
  className?: string;
}

const RequestStatusBadge = (props: Props) => {
  const { status, className } = props;
  const { t } = useTranslation();

  return (
    <InfoPlate
      variant={getPickupRequestStatusVariant(status)}
      className={className}
    >
      {t(`pickupRequests.statuses.${status}`, { defaultValue: status })}
    </InfoPlate>
  );
};

export default RequestStatusBadge;
